<app-quick-search-input 
  class="dialog-search-input" 
  placeholder="COMMON.search_through_catalog_and_more"
  [dialogMode]="true"
  [enableLastSearch]="true"
  (search)="navigateToSearch()"
  (searchByBundle)="navigateToSearch($event)"
  (closeSearch)="close()">
</app-quick-search-input>
